import { createDeferredI18n } from "#/shared/composables/useI18n";

// Mirrors `frontend.forms` in config/locales/frontend.en.yml. Shared by every form primitive, so
// one bundle fetch covers the page however many controls it renders.
//
// The bundle fetch resolves even when the request fails, and an unresolved key renders as the key
// itself, so these seed the instance: a failed fetch degrades to English rather than showing
// `checkbox_value_missing` in a validation bubble. The fetched bundle overwrites all of it,
// including a client's own overrides.
const FALLBACK_MESSAGES = {
  checkbox_value_missing: "Please check this box if you want to proceed.",
  select_value_missing: "Please select an item in the list.",
  switch_value_missing: "Please turn this on if you want to proceed.",
  date_value_missing: "Please pick a date.",
  date_previous_month: "Previous month",
  date_next_month: "Next month",
  date_prev: "Prev",
  date_next: "Next",
  date_range_shortcuts: "Shortcuts",
  date_range_today: "Today",
  date_range_yesterday: "Yesterday",
  date_range_last_7_days: "Last 7 Days",
  date_range_last_week: "Last Week (Mo-Su)",
  date_range_month_to_date: "Month to Date",
  date_range_previous_month: "Previous Month",
  date_range_year_to_date: "Year to Date",
  date_apply: "Apply",
  date_clear: "Clear",
  date_cancel: "Cancel",
  radio_group_value_missing: "Please select one of these options.",
  textarea_value_missing: "Please enter some text in this field.",
  textarea_too_long: "Please shorten this text to {maxlength} characters or less.",
  textarea_too_short: "Please lengthen this text to {minlength} characters or more.",
  otp_digit_label: "Digit {index} of {count}",
  results_loading: "Loading results",
  results_none: "No results",
  results_count: "{count} result | {count} results",
  results_count_with_suggestion:
    "No results. {title} suggested; press Enter to select. | {count} result. {title} suggested; press Enter to select. | {count} results. {title} suggested; press Enter to select.",
};

export const { i18n } = createDeferredI18n({ key: "forms" });

i18n.global.setLocaleMessage(i18n.global.locale.value, FALLBACK_MESSAGES);

/**
 * Translates a shared form string. Keys are relative to `frontend.forms`, which the i18n endpoint
 * serves as the message root, and resolve per client through that client's own locale files.
 *
 * @param {String} key
 * @param {Object} [values] - Values for the named placeholders of the message.
 * @returns {String}
 */
export function t(key, values) {
  return values ? i18n.global.t(key, values) : i18n.global.t(key);
}
